import React from 'react';

/* The mark and TRODO, set as on trodo.ai: small caps-spaced wordmark. One
 * component so every auth and onboarding page shows the same logo. */
export default function TrodoWordmark({ href, className = '' }) {
  const body = (
    <span className={`inline-flex items-center gap-[9px] ${className}`} style={{ color: 'var(--text-primary)' }}>
      <img src="/auth/trodo-mark.svg" alt="" width="20" height="20" className="block h-5 w-5" />
      <span style={{ fontSize: 13, fontWeight: 500, letterSpacing: '0.16em', lineHeight: 1, paddingTop: 1 }}>TRODO</span>
    </span>
  );
  return href ? <a href={href} aria-label="Trodo home" className="inline-block w-fit">{body}</a> : body;
}
